module.exports = __webpack_public_path__ + "media/images/suggestionIcon-ad250fa7.svg";